import React, { useState, Key, useEffect } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { useDictModel } from "../../../../base/dict/dictModel";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IItemDetailList, IMaterialDetailList, Ids, ItemDetailed, MaterialDetailed, IAppointmentField, IAppointmentSearch, IAppointmentDetail, IAppointmentRoSettleAndWhConfirm } from "../../appointmentTypes"
import { IStockStatisticFields, IStockStatisticSearch, IStockStatisticDetail, stockStatisticService } from "../../../../stock/statistic/stockStatisticService"
import { transPgToPagination, switchNum1, formatNum } from "@/utils/utils";
import { globalPrompt } from "@/components/message";
import moment, { Moment } from "moment";
import { appointmentService } from "../../appointmentService"
import { IVehicleDetail } from "../../../../base/customerFiles/vehicle/vehicleType"

import { itemService } from "../../../../base/item/itemService"
import { IItemDetail, IItemSearch } from "../../../../base/item/itemType"
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useLockFn } from "ahooks";
enum tabsType {
    Item = 1,
    Material = 2
}
export type IAppointmentType = {
    numAll: number,
    itemNumAll: number,
    totalAll: number,
    saleAll: number,
    discountAll: number,
    receivableAll: number,
    workHours: number,
    workHoursPrice: number,
    partPrice: number,
    [key: string]: any
}
export interface IMaterialDetailModel extends IStockStatisticDetail {
    num: number
}
export const getVehicleItem = (licensePlate: string, list: any[]) => {
    return list.find(item => item.licensePlate === licensePlate)
}
export const useAppointmentDetailsModel = createModel(function () {
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();
    const { supplieAllList, CustomerData, technicianData, user, setLocale } = useGlobalModel()
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)

    const [itemModel, setItemModel] = useState<boolean>(false); //维修项目弹框
    const [materialModel, setMaterialModel] = useState<boolean>(false); //维修项目弹框 
    const [checkList, setCheckList] = useState<number>(1);

    const [vehicleEditAll, setVehicleEditAll] = useState<IVehicleDetail[]>([])//实时切换车辆 编辑
    const [vehicleAddAll, setVehicleAddAll] = useState<IVehicleDetail[]>([])//实时切换车辆 新增

    const initDesc = {
        numAll: 0,  //数量
        itemNumAll: 0, //项数
        saleAll: 0,//销售金额

        workHours: 0, //工时
        workHoursPrice: 0, //工时费 折前
        workHoursDiscount: 0, //工时优惠
        workHoursTotal: 0, //工时总计 折后

        partPrice: 0, //零件费 折前
        partsDiscount: 0, //零件优惠
        partsTotal: 0, //零件总计 折后

        discountAll: 0,//优惠金额
        receivableAll: 0,//实收金额
        taxationAll: 0, //税费
        totalAll: 0, //总计        
    }

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initMaterialSearchParam: IStockStatisticSearch = {};
    //新增数据
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IAppointmentField>({ favorableAmount: 0, discountRate: 100, enterTime: moment(new Date()) })
    //新增详情列表
    // 维修项目
    const [detailItemAddList, setDetailItemAddList] = useState<IItemDetailList[]>([])
    // 维修用料
    const [detailMaterialAddList, setDetailMaterialAddList] = useState<IMaterialDetailList[]>([])

    //新增详情列表选中行
    // 维修项目
    const [detaiItemAddDataRowKeys, setDetaiItemAddDataRowKeys] = useState<Key[]>([]);
    const [detaiItemAddDataRow, setDetaiItemAddDataRow] = useState<IItemDetailList[]>([]);
    // 维修用料
    const [detaiMaterialAddDataRowKeys, setDetaiMaterialAddDataRowKeys] = useState<Key[]>([]);
    const [detaiMaterialAddDataRow, setDetaiMaterialAddDataRow] = useState<IMaterialDetailList[]>([]);
    const [addDesc, setAddDesc] = useState<IAppointmentType>(initDesc)


    //查看数据
    //查看详情form
    const [detailLookForm, setDetailLookForm] = useState<IAppointmentField>({ favorableAmount: 0 })
    //查看详情列表
    // 维修项目
    const [detailItemLookList, setDetailItemLookList] = useState<IItemDetailList[]>([])
    // 维修用料
    const [detailMaterialLookList, setDetailMaterialLookList] = useState<IMaterialDetailList[]>([])
    const [lookDesc, setLookDesc] = useState<IAppointmentType>(initDesc)


    //编辑数据
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IAppointmentField>({})
    //编辑详情列表
    // 维修项目
    const [detailItemEditList, setDetailItemEditList] = useState<IItemDetailList[]>([])
    // 维修用料
    const [detailMaterialEditList, setDetailMaterialEditList] = useState<IMaterialDetailList[]>([])

    //编辑详情列表选中行
    // 维修项目
    const [detaiItemEditDataRowKeys, setDetaiItemEditDataRowKeys] = useState<Key[]>([]);
    const [detaiItemEditDataRow, setDetaiItemEditDataRow] = useState<IItemDetailList[]>([]);
    // 维修用料
    const [detaiMaterialEditDataRowKeys, setDetaiMaterialEditDataRowKeys] = useState<Key[]>([]);
    const [detaiMaterialEditDataRow, setDetaiMaterialEditDataRow] = useState<IMaterialDetailList[]>([]);
    const [editDesc, setEditDesc] = useState<IAppointmentType>(initDesc)


    //配件列表配置
    const [workDataSource, setWorkDataSource] = useState<IMaterialDetailModel[]>([])
    const [searchWorkData, setSearchWorkData] = useState<IStockStatisticSearch>(initMaterialSearchParam)
    const [workPgCfg, setWorkPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选配件列表
    const [addDataSource, setAddDataSource] = useState<IMaterialDetailModel[]>([]);

    //项目列表配置
    const initItemSearchParam: IItemSearch = {}
    const [workItemDataSource, setWorkItemDataSource] = useState<IItemDetail[]>([])
    const [searchWorkItemData, setSearchWorkItemData] = useState<IItemSearch>(initItemSearchParam)
    const [workItemPgCfg, setWorkItemPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //已选项目列表
    const [addItemDataSource, setAddItemDataSource] = useState<IItemDetail[]>([]);

    useEffect(() => {
        let newDesc: IAppointmentType = { ...initDesc };
        detailItemAddList && detailItemAddList.forEach(item => {
            newDesc.workHours += Number(item.workHour);
            newDesc.workHoursPrice += Number(item.itemAmount);
            newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount);
            newDesc.workHoursTotal += Number(item.receivableAmount);
        });
        detailMaterialAddList && detailMaterialAddList.forEach(item => {
            newDesc.partPrice += Number(item.materialAmount)
            newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount)
            newDesc.partsTotal += Number(item.receivableAmount)
        })
        newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount
        newDesc.receivableAll = (newDesc.workHoursTotal + newDesc.partsTotal) * 1
        newDesc.taxationAll = (newDesc.workHoursTotal + newDesc.partsTotal) * 0.15
        // if ("favorableAmount" in detailAddForm) {
        //     newDesc.discountAll = newDesc.discountAll + Number(detailAddForm.favorableAmount)
        //     newDesc.receivableAll = newDesc.receivableAll - Number(detailAddForm.favorableAmount)
        // }
        setAddDesc(newDesc);
    }, [detailItemAddList, detailMaterialAddList, detailAddForm])

    useEffect(() => {
        let newDesc: IAppointmentType = { ...initDesc };
        detailItemEditList && detailItemEditList.forEach(item => {
            newDesc.workHours += Number(item.workHour);
            newDesc.workHoursPrice += Number(item.itemAmount);
            newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount);
            newDesc.workHoursTotal += Number(item.receivableAmount);
        });
        detailMaterialEditList && detailMaterialEditList.forEach(item => {
            newDesc.partPrice += Number(item.materialAmount)
            newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount)
            newDesc.partsTotal += Number(item.receivableAmount)
        })
        newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount
        newDesc.receivableAll = (newDesc.workHoursTotal + newDesc.partsTotal) * 1
        newDesc.taxationAll = (newDesc.workHoursTotal + newDesc.partsTotal) * 0.15

        // if ("favorableAmount" in detailEditForm) {
        //     newDesc.discountAll = newDesc.discountAll + Number(detailEditForm.favorableAmount)
        //     newDesc.receivableAll = newDesc.receivableAll - Number(detailEditForm.favorableAmount)
        // }
        setEditDesc(newDesc);
    }, [detailItemEditList, detailMaterialEditList, detailEditForm])

    useEffect(() => {
        let newDesc: IAppointmentType = { ...initDesc };
        detailItemLookList && detailItemLookList.forEach(item => {
            newDesc.workHours += Number(item.workHour);
            newDesc.workHoursPrice += Number(item.itemAmount);
            newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount);
            newDesc.workHoursTotal += Number(item.receivableAmount);
        });
        detailMaterialLookList && detailMaterialLookList.forEach(item => {
            newDesc.partPrice += Number(item.materialAmount)
            newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount)
            newDesc.partsTotal += Number(item.receivableAmount)
        })
        newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount
        newDesc.receivableAll = (newDesc.workHoursTotal + newDesc.partsTotal) * 1
        newDesc.taxationAll = (newDesc.workHoursTotal + newDesc.partsTotal) * 0.15

        // if ("favorableAmount" in detailLookForm) {
        //     newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount)
        //     newDesc.receivableAll = newDesc.receivableAll - Number(detailLookForm.favorableAmount)
        // }
        setLookDesc(newDesc);
    }, [detailItemLookList, detailMaterialLookList, detailLookForm])
    //新增表单缓存Item
    const updateAddFormVal = (val: IAppointmentField) => {
        let newVal = val;
        if ("customerCode" in val) {
            const { contact, phone, address, typeCode, typeName, code, name, } = getFindItem(val.customerCode as string, CustomerData)
            newVal = { ...val, contact, phone, customerAddress: address, customerName: name, licensePlate: "", vin: "", brandCode: "", brandName: "", vehicleModel: "" }
        }
        if ("licensePlate" in val) {
            const { contact, phone, address, typeCode, typeName, customerCode, customerName, vin, brandCode, brandName, model, licensePlate, categoryCode, categoryName } = getVehicleItem(val.licensePlate as string, vehicleAddAll)
            console.log(address)
            newVal = { ...val, contact, phone, licensePlate, vin, vehicleTypeCode: categoryCode, vehicleTypeName: categoryName, vehicleModel: model, customerAddress: address, customerName, customerCode }
        }
        if ("discountRate" in val) {
            let discountRate = +switchNum1(val.discountRate, "")
            newVal = { ...val, discountRate }
            setDetailItemAddList(detailItemAddList.map(item => {
                return {
                    ...item,
                    discountRate: discountRate,
                    receivableAmount: +(Number(item.itemAmount) * discountRate / 100).toFixed(2)
                }
            }))
            setDetailMaterialAddList(detailMaterialAddList.map(item => {
                return {
                    ...item,
                    discountRate: discountRate,
                    receivableAmount: +(Number(item.materialAmount) * discountRate / 100).toFixed(2)
                }
            }))
        }
        if ("serviceNatureCode" in val && val.serviceNatureCode === "service-nature.three-guarantees") {//维修类型为三包时，对维修项目，用料 进行置空操作
            let newDetailItemAddList = detailItemAddList.map((item) => {
                let { num, price, discountRate } = item
                num = +formatNum(num)
                price = +formatNum(price)
                discountRate = +formatNum(discountRate)
                return {
                    ...item,
                    price: price,
                    itemAmount: +formatNum(num * price),
                    receivableAmount: +formatNum(num * price * discountRate / 100),
                }
            })
            // console.log(detailMaterialAddList)
            let newDetailMaterialAddList = detailMaterialAddList.map((item) => {
                let { num, latestPurPrice, discountRate, purchasePrice } = item
                num = +formatNum(num)
                // latestPurPrice = +formatNum(latestPurPrice)
                let newPrice = +formatNum(latestPurPrice != 0 ? latestPurPrice : purchasePrice)

                discountRate = +formatNum(discountRate)
                return {
                    ...item,
                    price: newPrice,
                    materialAmount: +formatNum(num * newPrice),
                    receivableAmount: +formatNum(num * newPrice * discountRate / 100),
                }
            })
            setDetailItemAddList(newDetailItemAddList)
            setDetailMaterialAddList(newDetailMaterialAddList)
            newVal = { ...val }
        }
        if ("serviceNatureCode" in val && val.serviceNatureCode !== "service-nature.three-guarantees") {//维修类型不为三包时，对维修项目，用料 进行重新查询进行插值
            let searchDetailItemAddList = detailItemAddList.map(item => item.itemCode as string)
            let searchDetailMaterialAddList = detailMaterialAddList.map(item => item.stockId as string) || []
            searchDetailMaterialAddList.length != 0 && appointmentService.find(searchDetailMaterialAddList).then((resMaterial: any) => {
                setDetailMaterialAddList(resMaterial.map((item: IMaterialDetailList) => ({
                    ...item,
                    claimUnitCode: "",
                    num: 1,
                    discountRate: 100,
                    detailsId: item.id,
                    stockId: item.id,
                    // price: item.lateSalePrice,
                    // materialAmount: item.lateSalePrice,
                    // receivableAmount: item.lateSalePrice,
                    price: item.lateSalePrice || item.retailPrice,
                    materialAmount: item.lateSalePrice || item.retailPrice,
                    receivableAmount: item.lateSalePrice || item.retailPrice,
                })))
            })
            searchDetailItemAddList.length != 0 && appointmentService.projectQuery(searchDetailItemAddList).then((resItem: any) => {
                setDetailItemAddList(resItem.map((item: IItemDetailList) => ({
                    ...item,
                    id: "",
                    detailsId: item.id,
                    itemCode: item.code,
                    itemName: item.name,
                    claimUnitCode: "",
                    serviceTypeCode: item.typeCode,
                    serviceTypeName: item.typeName,
                    workHour: item.workHours,
                    technicianCode: [],
                    technicianName: [],
                    itemAmount: item.amount,
                    receivableAmount: item.amount,
                    discountRate: 100,
                })))
            })
            newVal = { ...val, discountRate: 100 }
        }
        setDetailAddForm({ ...detailAddForm, ...newVal })
    }
    //编辑表单缓存
    const updatEditFormVal = (val: IAppointmentField) => {
        let newVal = val;
        if ("customerCode" in val) {
            const { contact, phone, address, typeCode, typeName, code, name, } = getFindItem(val.customerCode as string, CustomerData)
            newVal = { ...val, contact, phone, customerAddress: address, customerName: name, licensePlate: "", vin: "", brandCode: "", brandName: "", vehicleModel: "" }
        }
        if ("licensePlate" in val) {
            console.log(getVehicleItem(val.licensePlateCode as string, vehicleAddAll))
            const { contact, phone, address, typeCode, typeName, customerCode, customerName, vin, brandCode, brandName, model, licensePlate, categoryCode, categoryName } = getVehicleItem(val.licensePlate as string, vehicleEditAll)
            newVal = { ...val, contact, phone, licensePlate, vin, vehicleTypeCode: categoryCode, vehicleTypeName: categoryName, vehicleModel: model, customerAddress: address, customerName, customerCode }
        }
        if ("discountRate" in val) {
            let discountRate = +switchNum1(val.discountRate, "")
            newVal = { ...val, discountRate }
            setDetailItemEditList(detailItemEditList.map(item => (
                {
                    ...item,
                    discountRate: discountRate,
                    receivableAmount: +(Number(item.itemAmount) * discountRate / 100).toFixed(2)
                }
            )))
            setDetailMaterialEditList(detailMaterialEditList.map(item => (
                {
                    ...item,
                    discountRate: discountRate,
                    receivableAmount: +(Number(item.materialAmount) * discountRate / 100).toFixed(2)
                }
            )))
        }
        if ("serviceNatureCode" in val && val.serviceNatureCode === "service-nature.three-guarantees") {//维修类型为三包时，对维修项目，用料 进行置空操作
            let newDetailItemEditList = detailItemEditList.map((item) => {
                let { num, price, discountRate } = item
                num = +formatNum(num)
                price = +formatNum(price)
                discountRate = +formatNum(discountRate)
                return {
                    ...item,
                    price: price,
                    itemAmount: +formatNum(num * price),
                    receivableAmount: +formatNum(num * price * discountRate / 100),
                }
            })
            let newDetailMaterialEditList = detailMaterialEditList.map((item) => {
                let { num, latestPurPrice, discountRate,purchasePrice } = item
                num = +formatNum(num)
                // latestPurPrice = +formatNum(latestPurPrice)
                let newPrice = +formatNum(latestPurPrice != 0 ? latestPurPrice : purchasePrice)
                discountRate = +formatNum(discountRate)
                return {
                    ...item,
                    price: newPrice,
                    materialAmount: +formatNum(num * newPrice),
                    receivableAmount: +formatNum(num * newPrice * discountRate / 100),
                }
            })
            setDetailItemEditList(newDetailItemEditList)
            setDetailMaterialEditList(newDetailMaterialEditList)
            newVal = { ...val, }
        }
        if ("serviceNatureCode" in val && val.serviceNatureCode !== "service-nature.three-guarantees") {//维修类型不为三包时，对维修项目，用料 进行重新查询进行插值

            let searchDetailItemEditList = detailItemEditList.map(item => item.itemCode as string)
            let searchDetailMaterialEditList = detailMaterialEditList.map(item => item.stockId as string) || []
            // return console.log(searchDetailMaterialEditList)
            searchDetailMaterialEditList.length != 0 && appointmentService.find(searchDetailMaterialEditList).then((resMaterial: any) => {
                setDetailMaterialEditList(resMaterial.map((item: IMaterialDetailList) => ({
                    ...item,
                    claimUnitCode: "",
                    num: 1,
                    discountRate: 100,
                    detailsId: item.id,
                    stockId: item.id,
                    // price: item.lateSalePrice,
                    // materialAmount: item.lateSalePrice,
                    // receivableAmount: item.lateSalePrice,
                    price: item.lateSalePrice || item.retailPrice,
                    materialAmount: item.lateSalePrice || item.retailPrice,
                    receivableAmount: item.lateSalePrice || item.retailPrice,
                })))
            })
            searchDetailItemEditList.length != 0 && appointmentService.projectQuery(searchDetailItemEditList).then((resItem: any) => {
                setDetailItemEditList(resItem.map((item: IItemDetailList) => ({
                    ...item,
                    id: "",
                    detailsId: item.id,
                    itemCode: item.code,
                    itemName: item.name,
                    claimUnitCode: "",
                    serviceTypeCode: item.typeCode,
                    serviceTypeName: item.typeName,
                    workHour: item.workHours,
                    technicianCode: [],
                    technicianName: [],
                    itemAmount: item.amount,
                    receivableAmount: item.amount,
                    discountRate: 100,
                })))
            })
            newVal = { ...val, discountRate: 100 }
        }
        setDetailEditForm({ ...detailEditForm, ...newVal })
    }
    //获取一条编辑或查看数据
    const getDetailEditOne = async (id: string, pattern: string) => {
        let { retData } = await appointmentService.one(id);
        const { materialDetails, itemDetails, enterTime, deliveryTime, ...from } = retData
        let newfrom = {
            ...from,
            technicianCodes: from.technicianCodes?.split(","),
            enterTime: enterTime ? moment(enterTime) : null,
            deliveryTime: deliveryTime ? moment(deliveryTime) : null
        }
        let newItemDetails = itemDetails?.map(item => {
            return {
                ...item,
                detailsId: item.id,
                amount: Number(item.workHour) * Number(item.price),
                technicianCode: item.technicianCode ? item.technicianCode.split(",") : [],
                technicianName: item.technicianName ? item.technicianName.split(",") : [],
            }
        })
        let newMaterialDetails = materialDetails?.map(item => {
            return {
                ...item,
                detailsId: item.id,
                amount: Number(item.num) * Number(item.price)
            }
        })
        if (retData && pattern == "edit") {
            setDetailItemEditList(newItemDetails as IItemDetailList[] ?? [])
            setDetailMaterialEditList(newMaterialDetails as IMaterialDetailList[] ?? [])
            setDetailEditForm(newfrom)
        } else if (retData && pattern == "look") {
            setDetailItemLookList(newItemDetails as IItemDetailList[] ?? [])
            setDetailMaterialLookList(newMaterialDetails as IMaterialDetailList[] ?? [])
            setDetailLookForm(newfrom);
        }
    }
    //重置弹框
    const resetMaterialData = async () => {
        setSearchWorkData({});
        workloadData(initPgCfg, {});
    }
    const resetItemData = async () => {

    }
    //加载配件数据
    const workloadData = async (page?: ISearchPage, searchValue: IStockStatisticSearch = searchWorkData) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await stockStatisticService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            let { lateSalePrice, retailPrice } = item
            return {
                ...item,
                num: 0,
                lateSalePrice: lateSalePrice || retailPrice,
                amount: item.lateSalePrice as number * 0,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }
    //加载维修项目数据
    const workloadItemData = async (page?: ISearchPage, searchValue: IItemSearch = searchWorkItemData) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await itemService.page(searchParams);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
            }
        })
        setWorkItemPgCfg(transPgToPagination(pg));
        setWorkItemDataSource(newRecords);
    }
    //重置维修项目数据
    const resetWorkloadItemData = () => {
        setSearchWorkItemData({});
        workloadItemData(initPgCfg, {});
    }
    // 筛选模块详情 详情和新增的列表已有数据的方法
    const modelScreenMethod = async (modelList: IMaterialDetailList[], detailList: IMaterialDetailList[], mode: string) => {
        const repetition: string[] = [];
        const newDetailData: IMaterialDetailList[] = []
        modelList.forEach(Item => {
            let isSelect = detailList && detailList.find(item => item.materialCode === Item.materialCode);
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    materialNameEn: Item.nameEn,
                    materialAmount: Item.amount,
                    receivableAmount: Number(Item.amount) * Number(mode == "add" ? detailAddForm?.discountRate : detailEditForm?.discountRate) / 100,
                    discountRate: mode == "add" ? detailAddForm?.discountRate : detailEditForm?.discountRate,
                    detailsId: Item.id,
                    stockId: Item.id,
                    price: Item.lateSalePrice,
                    id: "",
                });
            } else {
                repetition.push(Item.materialName as string);
            }
        })
        return { newDetailData, repetition }
    }
    //添加维修用料到详情列表
    const transformsToDetailList = async (mode: string) => {
        //添加列表
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailMaterialAddList, mode)
            setDetailMaterialAddList([...detailMaterialAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        } else if (mode == "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenMethod(addDataSource, detailMaterialEditList, mode)
            setDetailMaterialEditList([...detailMaterialEditList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `物料名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The material name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });
        }
    }
    //筛选维修项目详情 详情和新增的列表已有数据的方法
    const modelScreenItemMethod = async (modelList: IItemDetailList[], detailList: IItemDetailList[], mode: string) => {
        console.log(modelList, detailList)
        const repetition: string[] = [];
        const newDetailData: IItemDetailList[] = []
        modelList.forEach(Item => {
            let isSelect = detailList && detailList.find(item => item.itemCode === Item.itemCode);
            if (isSelect === undefined) {
                newDetailData.push({
                    ...Item,
                    detailsId: Item.id,
                    workHour: Item.workHours,
                    itemNameEn: Item.nameEn,
                    discountRate: mode == "add" ? detailAddForm?.discountRate : detailEditForm?.discountRate,
                    receivableAmount: Number(Item.amount) * Number(mode == "add" ? detailAddForm?.discountRate : detailEditForm?.discountRate) / 100,
                    itemAmount: Item.amount,
                    itemCode: Item.code,
                    itemName: Item.name,
                    technicianCode: [],
                    technicianName: [],
                    id: "",
                });
            } else {
                repetition.push(Item.itemName as string);
            }
        })
        return { newDetailData, repetition }
    }
    //添加维修项目到详情列表
    const transformsToItemDetailList = async (mode: string) => {
        //添加列表
        if (mode == "add") {
            const { repetition, newDetailData } = await modelScreenItemMethod(addItemDataSource, detailItemAddList, mode)
            setDetailItemAddList([...detailItemAddList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `项目名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The item name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });

        } else if (mode == "edit") {
            //详情列表
            const { repetition, newDetailData } = await modelScreenItemMethod(addItemDataSource, detailItemEditList, mode)
            setDetailItemEditList([...detailItemEditList, ...newDetailData])
            // repetition.length != 0 && globalPrompt("message", { text: `项目名称：${repetition.join(",")}，重复的将不在添加。`, type: "warning" });
            repetition.length != 0 && globalPrompt("message", { text: `${Locale["The item name of"]}${repetition.join(",")}${Locale["is repeated and will not be added."]}`, type: "warning" });
        }
    }
    //删除详情维修项目列表数据
    const detaiItemDetailList = async (mode: string) => {
        if (mode == "add") {
            const filterDetailList = detailItemAddList.filter(el => !!!detaiItemAddDataRowKeys.find(ele => ele === el.detailsId))
            setDetailItemAddList(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
            globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
        } else if (mode == "edit") {
            const backendDetailList: any = detaiItemEditDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);

            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = detailItemEditList.filter(el => !!!detaiItemEditDataRowKeys.find(ele => ele === el.detailsId))
                setDetailItemEditList(filterDetailList)
                // globalPrompt("message", { text: `删除成功`, type: "success" });
                globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
            }

            if (backendDetailList.length > 0) {
                await appointmentService.itemDelete({ ids: backendDetailList }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        // globalPrompt("message", { text: `删除失败`, type: "success" });
                        globalPrompt("message", { text: Locale["Unsuccessfully deleted"], type: "success" });

                    }
                })
            } else {
                deleteData()
            }
        }
    }
    //删除详情维修项目列表数据
    const detaiMaterialDetailList = async (mode: string) => {
        if (mode == "add") {
            const filterDetailList = detailMaterialAddList.filter(el => !!!detaiMaterialAddDataRowKeys.find(ele => ele === el.detailsId))
            setDetailMaterialAddList(filterDetailList)
            // globalPrompt("message", { text: `删除成功`, type: "success" });
            globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
        } else if (mode == "edit") {
            const backendDetailList: any = detaiMaterialEditDataRow.reduce((all, next) => {  //前端页面维护的需要删除的id
                if (next.id) {
                    all.push({ id: next.id });
                }
                return all;
            }, []);

            //删除详情列表调用的方法
            const deleteData = () => {
                const filterDetailList = detailMaterialEditList.filter(el => !!!detaiMaterialEditDataRowKeys.find(ele => ele === el.detailsId))
                setDetailMaterialEditList(filterDetailList)
                // globalPrompt("message", { text: `删除成功`, type: "success" });
                globalPrompt("message", { text: Locale["Successfully deleted"], type: "success" });
            }

            if (backendDetailList.length > 0) {
                await appointmentService.materialDelete({ ids: backendDetailList }).then(res => {
                    if (res.retData) {
                        deleteData()
                    } else {
                        // globalPrompt("message", { text: `删除失败`, type: "success" });
                        globalPrompt("message", { text: Locale["Unsuccessfully deleted"], type: "success" });
                    }
                })
            } else {
                deleteData()
            }
        }
    }
    const getTechnicianName = (technicianData: any, technicianCodes: any) => {
        const filterDetailList = technicianData.filter((el: any) => !!technicianCodes.find((ele: any) => ele === el.code))?.map((item: any) => item.name)
        return filterDetailList
    }
    //新增采购单
    const insertDetail = useLockFn(async (params: IAppointmentField) => {
        let { technicianCodes, enterTime, deliveryTime } = params
        // return console.log(enterTime)
        let TechnicianNames = technicianCodes ? getTechnicianName(technicianData, technicianCodes).toString() : null
        let newParams = {
            ...params,
            enterTime: enterTime ? moment(enterTime).format("YYYY-MM-DD HH:mm:ss") : null,
            deliveryTime: deliveryTime ? moment(deliveryTime).format("YYYY-MM-DD HH:mm:ss") : null,
            createUser: user.username,
            technicianCodes: params.technicianCodes ? params.technicianCodes.toString() : null,
            technicianNames: TechnicianNames,
            customerName: getFindItem(params.customerCode as string, CustomerData)?.name,
            vehicleTypeName: getTreeNodeName(params.vehicleTypeCode as string),
            serviceNatureName: getTreeNodeName(params.serviceNatureCode as string),
            serviceTypeName: getTreeNodeName(params.serviceTypeCode as string),
            itemDetails: detailItemAddList.map(item => ({ ...item, technicianCode: item.technicianCode.toString(), technicianName: item.technicianName.toString() })),
            materialDetails: detailMaterialAddList
        }
        let { retData } = await appointmentService.insert(newParams);
        return retData;
    })
    //编辑采购单
    const editDetail = useLockFn(async (params: IAppointmentField) => {
        let { technicianCodes, enterTime, deliveryTime } = params
        let TechnicianNames = technicianCodes ? getTechnicianName(technicianData, technicianCodes).toString() : null
        let newParams = {
            ...params,
            enterTime: enterTime ? moment(enterTime).format("YYYY-MM-DD HH:mm:ss") : null,
            deliveryTime: deliveryTime ? moment(deliveryTime).format("YYYY-MM-DD HH:mm:ss") : null,
            technicianCodes: params.technicianCodes ? params.technicianCodes.toString() : null,
            technicianNames: TechnicianNames,
            updateUser: user.username,
            customerName: getFindItem(params.customerCode as string, CustomerData)?.name,
            vehicleTypeName: getTreeNodeName(params.vehicleTypeCode as string),
            serviceNatureName: getTreeNodeName(params.serviceNatureCode as string),
            serviceTypeName: getTreeNodeName(params.serviceTypeCode as string),
            itemDetails: detailItemEditList.map(item => ({ ...item, technicianCode: item.technicianCode.toString(), technicianName: item.technicianName.toString() })),
            materialDetails: detailMaterialEditList
        }
        let { retData } = await appointmentService.update(newParams);
        return retData;
    })
    //结算操作
    const Settle = useLockFn(async (data: IAppointmentField) => {
        const params = {
            reckoner: user.username,
            ...data
        }
        let { retData } = await appointmentService.settl(params);
        return retData
    })
    //出库操作
    const WhConfirm = useLockFn(async (data: IAppointmentField) => {
        const params = {
            reckoner: user.username,
            ...data
        }
        let { retData } = await appointmentService.warehousing(params);
        return retData
    })

    //关闭页签清不同状态缓存
    const resetAddCatch = async (type: string) => {
        setDetailAddForm({ favorableAmount: 0, discountRate: 100, enterTime: moment(new Date()) })
        setDetailItemAddList([]);
        setDetailMaterialAddList([]);
    }
    const resetEditCatch = async (type: string) => {
        setDetailEditForm({});
        setDetailItemEditList([]);
        setDetailMaterialEditList([]);
    }

    //商品进销存明细
    const [materialHistoryModel, setMaterialHistoryModel] = useState<boolean>(false); //商品进销存明细弹框 
    const [materialHistoryRow, setMaterialHistoryRow] = useState<IMaterialDetailList>({}); //商品进销存明细弹框 
    const [materialHistoryType, setMaterialHistoryType] = useState<string>("trade-type.purchase")//trade-type.sale 查询历史状态

    return {
        itemModel,
        materialModel,
        checkList,
        vehicleEditAll,
        vehicleAddAll,
        detailAddForm,
        detailItemAddList,
        detailMaterialAddList,
        detaiItemAddDataRowKeys,
        detaiItemAddDataRow,
        detaiMaterialAddDataRowKeys,
        detaiMaterialAddDataRow,
        addDesc,
        detailLookForm,
        detailItemLookList,
        detailMaterialLookList,
        lookDesc,
        detailEditForm,
        detailItemEditList,
        detailMaterialEditList,
        detaiItemEditDataRowKeys,
        detaiItemEditDataRow,
        detaiMaterialEditDataRowKeys,
        detaiMaterialEditDataRow,
        editDesc,
        workDataSource,
        searchWorkData,
        workPgCfg,
        addDataSource,
        workItemDataSource,
        searchWorkItemData,
        workItemPgCfg,
        addItemDataSource,
        initPgCfg,
        setItemModel,
        setMaterialModel,
        setCheckList,
        setVehicleEditAll,
        setVehicleAddAll,
        setDetailAddForm,
        setDetailItemAddList,
        setDetailMaterialAddList,
        setDetaiItemAddDataRowKeys,
        setDetaiItemAddDataRow,
        setDetaiMaterialAddDataRowKeys,
        setDetaiMaterialAddDataRow,
        setAddDesc,
        setDetailLookForm,
        setDetailItemLookList,
        setDetailMaterialLookList,
        setLookDesc,
        setDetailEditForm,
        setDetailItemEditList,
        setDetailMaterialEditList,
        setDetaiItemEditDataRowKeys,
        setDetaiItemEditDataRow,
        setDetaiMaterialEditDataRowKeys,
        setDetaiMaterialEditDataRow,
        setEditDesc,
        setWorkDataSource,
        setSearchWorkData,
        setWorkPgCfg,
        setAddDataSource,
        setWorkItemDataSource,
        setSearchWorkItemData,
        setWorkItemPgCfg,
        setAddItemDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetMaterialData,
        workloadData,
        workloadItemData,
        resetWorkloadItemData,
        modelScreenMethod,
        transformsToDetailList,
        modelScreenItemMethod,
        transformsToItemDetailList,
        detaiItemDetailList,
        detaiMaterialDetailList,
        getTechnicianName,
        insertDetail,
        editDetail,
        Settle,
        WhConfirm,
        resetAddCatch,
        resetEditCatch,
        materialHistoryModel,
        setMaterialHistoryModel,
        materialHistoryRow,
        setMaterialHistoryRow,
        materialHistoryType,
        setMaterialHistoryType
    }
});